import { EmploymentDetailType } from '~/data/employment/useEmploymentDetails';
import { EmploymentDetailsProposalProps } from '~/data/proposals';
import { scheduledDateFormats } from '~/features/ScheduledEmploymentChanges/helpers';
import { mapSubmitDataUtils } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common';

export const emplDetailsNewTypeToLegacy = (
  data: EmploymentDetailsProposalProps,
): EmploymentDetailType => {
  const { submissionDateInFormat } = mapSubmitDataUtils({
    defaultSubmissionDateFormat: scheduledDateFormats.dashFormat,
  });
  const {
    proposalData: { ed: proposalData, customData },
  } = data;

  return {
    fEmplId: data.targetId,
    fEmplDetailStartDate: submissionDateInFormat(proposalData!.start_date),
    fEmplDetailStatus: proposalData!.employment_status_fk,
    fEmplDetailJobGrade: proposalData!.job_grade_fk || undefined,
    fEmplDetailTaxNumber: proposalData!.tax_number || undefined,
    fEmplDetailPersonnelGroup1: proposalData!.personnel_group_1_fk || undefined,
    fEmplDetailPersonnelGroup2: proposalData!.personnel_group_2_fk || undefined,
    fEmplDetailPersonnelGroup3: proposalData!.personnel_group_3_fk || undefined,
    fEmplDetailPersonnelGroup4: proposalData!.personnel_group_4_fk || undefined,
    fEmplDetailPersonnelGroup5: proposalData!.personnel_group_5_fk || undefined,
    fEmplDetailVacBalCalcSixDays: proposalData!.vac_bal_calc_use_six_days,
    fEmplDetailCalcHoursBalance: proposalData!.calc_hours_balance,
    fEmplDetailCustomData: customData,
  };
};
